import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AsyncErrorHandler } from 'lib/ui';
import { CheckDuplicatePenPipeSDR, PenPipeSDRDto } from 'models/pen/PenPipeSDR';
import { PenPipeSDRService } from 'services/pen/pen-pipe-SDR-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class PenPipeSDRNew {
  private penPipeSdr: PenPipeSDRDto = new PenPipeSDRDto();
  protected checkDuplicateData: CheckDuplicatePenPipeSDR = new CheckDuplicatePenPipeSDR();

  private constructor(
    private router: Router,
    private toastService: ToastService,
    private eventAggregator: EventAggregator,
    private penPipeSDRService: PenPipeSDRService
  ) {}

  @AsyncErrorHandler
  async createPenPipeSDR() {
    if (await this.checkDuplicate()) return;

    this.penPipeSdr.Name = this.penPipeSdr.SDR.toString();
    await this.penPipeSDRService.post(this.penPipeSdr);
    this.eventAggregator.publish('penPipeSDRsReset', 1);
    this.toastService.showSuccess('pens.penPipeSDRCreated');
    this.router.navigateToRoute('pen-pipe-sdr-list');
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.SDR = this.penPipeSdr.SDR;
    const { IsDuplicate } = await this.penPipeSDRService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('penPipeSDRIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }
}
